import { render } from "./shipping_fee_config.vue?vue&type=template&id=19b9d3a4&ts=true"
import script from "./shipping_fee_config.vue?vue&type=script&lang=ts"
export * from "./shipping_fee_config.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__